module.exports = __webpack_public_path__ + "media/images/img-pet-2-bf2e74dc.jpg";